<template>
  <div class="footer">
    <div class="item"> 15810204162 &nbsp;&nbsp; wuyinzun@gmail.com</div>
    <div class="item"> 北京市经济技术开发区地盛北街1号院31号楼1层 </div>
    <div> 2020-2025 北京淏睿科技发展有限公司 经营许可证编号：<a class="blue-link" href ="https://beian.miit.gov.cn/#/Integrated/index"  target="_blank">京ICP备16022450号-2</a> </div>
  </div>
</template>

<script>
export default {
  name: "Footers",
  data() {
    return {

    }
  },

  methods: {

  }
};
</script>

<style lang="less" scoped>
.footer{
  background: #3E4348;
  font-size: 22px;
  color: #fff;
  text-align: center;
  padding: 66px 0;
  .item{
    margin-bottom: 20px;
  }
}

.blue-link {
  color: #1890ff; /* 蓝色字体 */
  text-decoration: none; /* 可选：去掉下划线 */
  &:hover {
    text-decoration: underline; /* 鼠标悬停时显示下划线 */
  }
}
</style>